// import env from './env.sandbox'
import env from './env.production'
// import env from './env.development'

export default env